var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.65,
    height: 115.65,
    viewBox: "0 0 115.65 115.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TROPHY",
    transform: "translate(2.83 -17.869) rotate(9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trophy-2",
    "data-name": "trophy",
    transform: "translate(0 18.092) rotate(-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4446",
    "data-name": "Path 4446",
    d: "M42.118,21.2,20.952,23.53,0,21.2c9.911,0,13.387-7.095,14.064-16.482.091-1.243.13-2.525.13-3.835V0a33.676,33.676,0,0,0,7.1.726A33.9,33.9,0,0,0,28.156.051V.887c0,1.326.037,2.625.126,3.881C28.924,14.132,32.224,21.2,42.118,21.2Z",
    transform: "translate(36.533 63.266)",
    fill: "#fad207"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4447",
    "data-name": "Path 4447",
    d: "M57.941,4.929V12.8L28.971,15.125,0,12.8V4.929A4.928,4.928,0,0,1,4.929,0H53.013a4.927,4.927,0,0,1,4.929,4.929Z",
    transform: "translate(28.622 84.469)",
    fill: "#fad207"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4448",
    "data-name": "Path 4448",
    d: "M57.727,3.49H5.817A2.328,2.328,0,0,0,3.49,5.817V12.8H0V4.929A4.928,4.928,0,0,1,4.929,0H53.013a4.929,4.929,0,0,1,4.714,3.49Z",
    transform: "translate(28.622 84.469)",
    fill: "#faa515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4449",
    "data-name": "Path 4449",
    d: "M14.218,5.045a39.339,39.339,0,0,1-6.99.612A38.926,38.926,0,0,1,0,5C.091,3.755.13,2.473.13,1.163V.277L7.228,0l6.865.328v.835C14.092,2.49,14.129,3.788,14.218,5.045Z",
    transform: "translate(50.598 62.989)",
    fill: "#faa515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4450",
    "data-name": "Path 4450",
    d: "M35.835,3.49a31.334,31.334,0,0,1-31.3,31.3H0A38.124,38.124,0,0,0,5.285,27.8,24.358,24.358,0,0,0,28.605,6.981H12.761c.491-2.534.838-4.9,1.082-6.981h18.5A3.492,3.492,0,0,1,35.835,3.49Z",
    transform: "translate(79.815 20.128)",
    fill: "#fad207"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4451",
    "data-name": "Path 4451",
    d: "M11.072,0Q10.22,1.693,9.28,3.265a45.066,45.066,0,0,1-3.1,4.563q-.813.045-1.638.044H0L.516,4.529,5.284.88A46.189,46.189,0,0,0,11.072,0Z",
    transform: "translate(79.815 47.044)",
    fill: "#faa515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4452",
    "data-name": "Path 4452",
    d: "M7.486,0q-.031.269-.063.545c-.256,2.169-.579,4.33-.968,6.436H1.72L0,3.49,2.8,0Z",
    transform: "translate(90.856 20.128)",
    fill: "#faa515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4453",
    "data-name": "Path 4453",
    d: "M29.66,3.49A31.336,31.336,0,0,1,0,34.744a45.067,45.067,0,0,0,3.1-4.563Q4.043,28.61,4.9,26.916A24.389,24.389,0,0,0,22.43,6.981H11.321c.389-2.106.712-4.268.968-6.436Q12.32.269,12.352,0H26.169A3.492,3.492,0,0,1,29.66,3.49Z",
    transform: "translate(85.991 20.128)",
    fill: "#fad207"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4454",
    "data-name": "Path 4454",
    d: "M35.835,34.788H31.3A31.334,31.334,0,0,1,0,3.49,3.492,3.492,0,0,1,3.49,0h18.5c.244,2.078.591,4.447,1.082,6.981H7.23A24.358,24.358,0,0,0,30.551,27.8,38.125,38.125,0,0,0,35.835,34.788Z",
    transform: "translate(0 20.128)",
    fill: "#fad207"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4455",
    "data-name": "Path 4455",
    d: "M5.766,6.981H1.031C.642,4.873.319,2.711.063.545Q.031.269,0,0H4.684L7.5,3.573Z",
    transform: "translate(17.308 20.128)",
    fill: "#faa515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4456",
    "data-name": "Path 4456",
    d: "M11.072,7.872H6.534q-.824,0-1.638-.044a45.065,45.065,0,0,1-3.1-4.563Q.853,1.694,0,0A46.194,46.194,0,0,0,5.787.88L10.13,3.952Z",
    transform: "translate(24.764 47.044)",
    fill: "#faa515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4457",
    "data-name": "Path 4457",
    d: "M80.28,0H4.654A4.654,4.654,0,0,0,0,4.654v9.075a4.654,4.654,0,0,0,4.654,4.654H80.28a4.654,4.654,0,0,0,4.654-4.654V4.654A4.654,4.654,0,0,0,80.28,0Z",
    transform: "translate(15.358 97.267)",
    fill: "#50758d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4458",
    "data-name": "Path 4458",
    d: "M9.308,18.383H4.654A4.653,4.653,0,0,1,0,13.729V4.654A4.653,4.653,0,0,1,4.654,0V13.729A4.653,4.653,0,0,0,9.308,18.383Z",
    transform: "translate(15.358 97.267)",
    fill: "#2b597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4459",
    "data-name": "Path 4459",
    d: "M72.834,0s0,1.768-.228,4.654c-.084,1.061-.2,2.276-.356,3.607-.244,2.078-.591,4.447-1.082,6.981-1.275,6.541-3.518,14.185-7.477,20.815a38.124,38.124,0,0,1-5.285,6.993,28.763,28.763,0,0,1-15.125,8.4,33.9,33.9,0,0,1-6.865.675,33.677,33.677,0,0,1-7.1-.726,28.739,28.739,0,0,1-14.893-8.349,38.125,38.125,0,0,1-5.285-6.993c-3.958-6.63-6.2-14.274-7.477-20.815-.491-2.534-.838-4.9-1.082-6.981C.428,6.93.312,5.715.228,4.654,0,1.768,0,0,0,0Z",
    transform: "translate(21.408 11.868)",
    fill: "#fad207"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4461",
    "data-name": "Path 4461",
    d: "M44.329,3.49H1.745a1.745,1.745,0,0,1,0-3.49H44.329a1.745,1.745,0,0,1,0,3.49Z",
    transform: "translate(34.788 104.83)",
    fill: "#2b597f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4462",
    "data-name": "Path 4462",
    d: "M72.834,2.327,34.917,0,4.654,2.327H0S0,4.1.228,6.981c.084,1.061.2,2.276.356,3.607.244,2.078.591,4.447,1.082,6.981C2.941,24.11,5.184,31.754,9.143,38.383a38.125,38.125,0,0,0,5.285,6.993A28.739,28.739,0,0,0,29.32,53.725a33.677,33.677,0,0,0,7.1.726q1.187,0,2.32-.072a32.65,32.65,0,0,1-4.763-.654,28.739,28.739,0,0,1-14.893-8.349A38.125,38.125,0,0,1,13.8,38.383C9.838,31.754,7.6,24.11,6.32,17.569c-.491-2.534-.838-4.9-1.082-6.981l0-.04A3.2,3.2,0,0,1,8.415,6.981H72.606c.228-2.885.228-4.654.228-4.654Z",
    transform: "translate(21.408 9.541)",
    fill: "#faa515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4463",
    "data-name": "Path 4463",
    d: "M5.934,0H79a5.934,5.934,0,1,1,0,11.868H5.934A5.934,5.934,0,0,1,5.934,0Z",
    transform: "translate(15.358 0)",
    fill: "#fad207"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4464",
    "data-name": "Path 4464",
    d: "M10.588,11.868H5.934A5.934,5.934,0,0,1,5.934,0h4.654a5.934,5.934,0,1,0,0,11.868Z",
    transform: "translate(15.358 0)",
    fill: "#faa515"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.a99bff99.svg";
export { ForwardRef as ReactComponent };